export default __webpack_public_path__ + "static/media/li.a4637b25.svg";